import React, { useContext } from 'react'
import {
    StyledPaperPromoContainer,
    StyledLink,
    StyledImage,
    StyledCTA,
    StyledImageFrame,
    StyledNewspaperImage,
    StyledFallbackImage,
} from './PaperPromo.styled'
import { format, subDays } from 'date-fns'
import { scaleImage } from '@news-mono/web-common'
import { isBetweenUTC } from '@news-mono/web-common'
import { SectionHeader } from '../../section-header/SectionHeader/SectionHeader'
import { ConfigurationContext } from '@news-mono/web-common'

const paperBackground = require('./assets/blank-background.png')
const fallback = require('./assets/cover-fallback.png')
const fallback2x = require('./assets/cover-fallback@2x.png')

// Function export and prop is for unit testing
export function determineCoverDate(now = new Date()) {
    const isBetweenCutoff = isBetweenUTC(now, [16, 0], [18, 0]) // Between 12am and 2am (while SMedia prepare digital edition)
    const imageDate = isBetweenCutoff ? subDays(now, 1) : now

    return format(imageDate, 'yyyyMMdd')
}

function buildTodaysPaperSrcSets() {
    const imageDateSuffix = determineCoverDate()
    const imagePath = `https://images.thewest.com.au/assets/frontpage/frontpage-${imageDateSuffix}.jpg`
    const cover1x = scaleImage(imagePath, 320)
    const cover2x = scaleImage(imagePath, 640)

    return [cover1x, cover2x]
}

export const PaperPromo = () => {
    const [coverImage1x, coverImage2x] = buildTodaysPaperSrcSets()
    const [displayFallback, setDisplayFallback] = React.useState(false)
    const { publicUrl } = useContext(ConfigurationContext)

    return (
        <StyledPaperPromoContainer>
            <SectionHeader heading="Today's Paper" hasMargin={true} />
            {/**
             * If this component is extended to work with regionals the following link will need
             * to be updated to include the section as well as an updated utm_source
             */}
            <StyledLink
                to={`${publicUrl}/digital-edition?utm_source=TheWest&utm_medium=Referral&utm_campaign=digital-edition&utm_term=todays-paper&utm_content=homepagecard`}
            >
                {displayFallback ? (
                    <StyledFallbackImage
                        enableFadeIn={false}
                        src={fallback}
                        srcSet={`${fallback2x} 2x`}
                        alt=""
                        loading="lazy"
                    />
                ) : (
                    <StyledImageFrame>
                        <StyledNewspaperImage
                            enableFadeIn={false}
                            src={paperBackground}
                            alt=""
                            loading="lazy"
                        />
                        <StyledImage
                            enableFadeIn={false}
                            src={coverImage1x}
                            srcSet={`${coverImage2x} 2x`}
                            alt=""
                            loading="lazy"
                            onError={() => {
                                setDisplayFallback(true)
                            }}
                        />
                    </StyledImageFrame>
                )}
                <StyledCTA>
                    <span>Read the Paper</span>
                </StyledCTA>
            </StyledLink>
        </StyledPaperPromoContainer>
    )
}
